import React, { useState } from 'react';
import { InputTextArea, Modal as SparkModal, SparkModalPortal } from '@spark';
import { editFieldsTitle } from '../utils/playgroundFields';

const initialDraft = (fields, fieldValues) =>
    Object.fromEntries(
        fields.map((field) => {
            const value = fieldValues?.[field];
            return [field, value === null || value === undefined ? '' : String(value)];
        })
    );

/** Modal body + footer state. Keyed by row from the parent so a different
 *  example always starts from that example's current values. */
const EditFieldsForm = ({ rowId, exampleIndex, fields, fieldValues, onApply, onCancel }) => {
    const [draft, setDraft] = useState(() => initialDraft(fields, fieldValues));

    return (
        <SparkModal
            className="pg-edit-fields-modal fs-unmask"
            title={editFieldsTitle(fields.length, exampleIndex)}
            showSubtitle={false}
            showScrollBar={false}
            fixedHeight={false}
            showFooter
            primaryLabel="Apply"
            tertiaryLabel="Cancel"
            onPrimaryClick={() => onApply(rowId, draft)}
            onTertiaryClick={onCancel}
            onCloseClick={onCancel}
        >
            <div className="pg-edit-fields-modal__body">
                {fields.map((field) => (
                    <InputTextArea
                        key={field}
                        className="pg-edit-fields-modal__field"
                        label={field}
                        placeholder=""
                        value={draft[field] ?? ''}
                        size="small"
                        rows={1}
                        onChange={(event) =>
                            setDraft((prev) => ({ ...prev, [field]: event.target.value }))
                        }
                    />
                ))}
            </div>
        </SparkModal>
    );
};

/**
 * "Edit <n> Dynamic fields - Example #01" (Figma 2126:76764): one textarea
 * per dataset field the prompts reference, pre-filled with the example's
 * current values. Apply hands the edited values back for that row only.
 */
const EditFieldsModal = ({
    open,
    rowId,
    exampleIndex,
    fields = [],
    fieldValues = {},
    onApply,
    onCancel,
}) => (
    <SparkModalPortal open={open} onClose={onCancel} size="text">
        {open && (
            <EditFieldsForm
                key={rowId}
                rowId={rowId}
                exampleIndex={exampleIndex}
                fields={fields}
                fieldValues={fieldValues}
                onApply={onApply}
                onCancel={onCancel}
            />
        )}
    </SparkModalPortal>
);

export default EditFieldsModal;
